import React, { useEffect, useState } from "react";
import { firestore } from "../firebase";

import SiteDataService from "../services/site.services";

import firebase from "firebase/compat/app";
import { snapshotEqual, update } from "firebase/firestore";
import { useParams, Link } from "react-router-dom";
import { useUserProvider } from "../context/UserProvider";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify"; // then this

import {
  Card,
  CardContent,
  Button,
  TextField,
  Stack,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Grid,
  Typography,
} from "@mui/material";
import { snapshotViewportBox } from "framer-motion";

const EditSite = () => {
  const history = useHistory();
  const { id } = useParams();

  const initialFieldValues = {
    siteStreet: "",
    siteNumber: "",
  };

  const siteRef = firestore.doc(`sites/${id}`);

  const [siteStreet, setSiteStreet] = useState("");
  const [siteStreetError, setSiteStreetError] = useState(false);
  const [siteNumber, setSiteNumber] = useState("");
  const [siteNumberError, setSiteNumberError] = useState(false);
  const [siteHousingType, setSiteHousingType] = useState("");
  const [siteHousingTypeError, setSiteHousingTypeError] = useState(false);
  const [sitePostalCode, setSitePostalCode] = useState("");
  const [siteConstructionYear, setSiteConstructionYear] = useState("");
  const [siteNotes, setSiteNotes] = useState("");
  const [siteMunicipality, setSiteMunicipality] = useState("");

  const [clientCompany, setClientCompany] = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [clientFirstName, setClientFirstName] = useState("");
  const [clientLastName, setClientLastName] = useState("");
  const [clientTelephone, setClientTelephone] = useState("");

  const [entrepreneurCompany, setEntrepreneurCompany] = useState("");
  const [entrepreneurCompanyNumber, setEntrepreneurCompanyNumber] =
    useState("");
  const [entrepreneurEmail, setEntrepreneurEmail] = useState("");
  const [entrepreneurFirstName, setEntrepreneurFirstName] = useState("");
  const [entrepreneurLastName, setEntrepreneurLastName] = useState("");
  const [entrepreneurTelephone, setEntrepreneurTelephone] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (siteStreet === "" || siteNumber === "" || siteHousingType === "") {
      toast.error("Please complete the required fields", { theme: "colored" });
      return;
    }
    siteRef.update({
      siteStreet: siteStreet,
      siteNumber: siteNumber,
      sitePostalCode: sitePostalCode,

      siteHousingType: siteHousingType,
      siteConstructionYear: siteConstructionYear,
      siteNotes: siteNotes,
      siteMunicipality: siteMunicipality,
      clientCompany: clientCompany,
      clientEmail: clientEmail,
      clientFirstName: clientFirstName,
      clientLastName: clientLastName,
      clientTelephone: clientTelephone,
      entrepreneurCompany: entrepreneurCompany,
      entrepreneurCompanyNumber: entrepreneurCompanyNumber,
      entrepreneurEmail: entrepreneurEmail,
      entrepreneurFirstName: entrepreneurFirstName,
      entrepreneurLastName: entrepreneurLastName,
      entrepreneurTelephone: entrepreneurTelephone,
    });
    history.push(`/sites/${id}`);
    toast.success("Site updated successfully", {
      theme: "colored",
    });
    setSiteStreet("");
    setSiteNumber("");
    setSitePostalCode("");
    setSiteHousingType("");
    setSiteConstructionYear("");
    setSiteNotes("");
    setSiteMunicipality("");
    setClientCompany("");
    setClientEmail("");
    setClientFirstName("");
    setClientLastName("");
    setClientTelephone("");
    setEntrepreneurCompany("");
    setEntrepreneurCompanyNumber("");
    setEntrepreneurEmail("");
    setEntrepreneurFirstName("");
    setEntrepreneurLastName("");
    setEntrepreneurTelephone("");
  };

  const editHandler = async () => {
    // setMessage("");
    try {
      const docSnap = await SiteDataService.getSite(id);
      // console.log("the record is :", docSnap.data());
      setSiteStreet(docSnap.data().siteStreet);
      setSiteNumber(docSnap.data().siteNumber);
      setSitePostalCode(docSnap.data().sitePostalCode);

      setSiteHousingType(docSnap.data().siteHousingType);
      setSiteConstructionYear(docSnap.data().siteConstructionYear);
      setSiteNotes(docSnap.data().siteNotes);
      setSiteMunicipality(docSnap.data().siteMunicipality);
      setClientCompany(docSnap.data().clientCompany);
      setClientEmail(docSnap.data().clientEmail);
      setClientFirstName(docSnap.data().clientFirstName);
      setClientLastName(docSnap.data().clientLastName);
      setClientTelephone(docSnap.data().clientTelephone);
      setEntrepreneurCompany(docSnap.data().entrepreneurCompany);
      setEntrepreneurCompanyNumber(docSnap.data().entrepreneurCompanyNumber);
      setEntrepreneurEmail(docSnap.data().entrepreneurEmail);
      setEntrepreneurFirstName(docSnap.data().entrepreneurFirstName);
      setEntrepreneurLastName(docSnap.data().entrepreneurLastName);
      setEntrepreneurTelephone(docSnap.data().entrepreneurTelephone);
    } catch (err) {
      // setMessage({ error: true, msg: err.message });
      toast.error("Please complete the required fields", { theme: "colored" });
    }
  };

  useEffect(() => {
    // console.log("The id here is : ", id);
    // if (id !== undefined && id !== "") {
    editHandler();
    // }
  }, [id]);

  // siteRef
  //   .update({
  //     // clientCompany: clientCompany,
  //     // clientEmail: clientEmail,
  //     // clientFirstName: clientFirstName,
  //     // clientLastName: clientLastName,
  //     // clientTelephone: clientTelephone,
  //     // entrepreneurCompany: entrepreneurCompany,
  //     // entrepreneurCompanyNumber: entrepreneurCompanyNumber,
  //     // entrepreneurEmail: entrepreneurEmail,
  //     // entrepreneurFirstName: entrepreneurFirstName,
  //     // entrepreneurLastName: entrepreneurLastName,
  //     // entrepreneurTelephone: entrepreneurTelephone,
  //     // siteConstructionYear: siteConstructionYear,
  //     // siteHousingType: siteHousingType,
  //     // siteMunicipality: siteMunicipality,
  //     // siteNotes: siteNotes,
  //     siteNumber: siteNumber,
  //     // sitePostalCode: sitePostalCode,
  //     siteStreet: siteStreet,
  //   })
  //   .then(() => {
  //     history.push("/");
  //     toast.success("Site created successfully", {
  //       theme: "colored",
  //     });
  //   })
  //   .catch((error) => {
  //     toast.error("Please complete the required fields", {
  //       theme: "colored",
  //     });
  //   });
  // setSiteStreet("");
  // setSiteNumber("");
  // // } else {
  // //   history.push("/");
  // // }

  // function fetchUserCreds() {
  //   firebase
  //     .firestore()
  //     .collection("sites")
  //     .doc(id)
  //     .get()
  //     .then((snapshot) => {
  //       siteStreet(snapshot.siteStreet);
  //       setSiteNumber(snapshot.siteNumber);
  //       history.push("/");
  //       toast.success("Site created successfully", {
  //         theme: "colored",
  //       });
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // }
  return (
    <form onSubmit={handleSubmit}>
      <Card sx={{ marginBottom: "30px" }}>
        <CardContent>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography variant="h6">Site informations</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <TextField
                  fullWidth
                  error={siteStreetError}
                  type="text"
                  name="Site Street"
                  label="Site Street"
                  // placeholder="Site Street"
                  value={siteStreet}
                  // value={siteStreet}
                  // value={
                  //   siteStreet != "" ? siteStreet : siteStreet
                  // }
                  // initialValue={siteStreet}
                  onChange={(e) => setSiteStreet(e.target.value)}
                />
                <TextField
                  fullWidth
                  error={siteNumberError}
                  type="number"
                  name="Street number"
                  label="Street number"
                  // placeholder="Street number"
                  // value={siteNumber}
                  value={siteNumber}
                  onChange={(e) => setSiteNumber(e.target.value)}
                />
                <TextField
                  fullWidth
                  type="number"
                  name="Postal code"
                  label="Postal code"
                  // placeholder="Postal code"
                  // value={sitePostalCode}
                  value={sitePostalCode}
                  onChange={(e) => setSitePostalCode(e.target.value)}
                />
                <TextField
                  fullWidth
                  type="text"
                  name="Municipality"
                  label="Municipality"
                  // placeholder="Municipality"
                  // value={siteMunicipality}
                  value={siteMunicipality}
                  onChange={(e) => setSiteMunicipality(e.target.value)}
                />
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Housing Type
                  </InputLabel>
                  <Select
                    fullWidth
                    error={siteHousingTypeError}
                    labelId="demo-simple-select-label"
                    label="Housing Type"
                    id="demo-simple-select"
                    // value={siteHousingType}
                    value={siteHousingType}
                    onChange={(e) => setSiteHousingType(e.target.value)}
                  >
                    <MenuItem value="House">House</MenuItem>
                    <MenuItem value="Appartment">Appartment</MenuItem>
                    <MenuItem value="Office">Office</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                </FormControl>
                <TextField
                  fullWidth
                  type="number"
                  name="Year of construction"
                  label="Year of construction"
                  // placeholder="Year of construction"
                  // value={siteConstructionYear}
                  value={siteConstructionYear}
                  onChange={(e) => setSiteConstructionYear(e.target.value)}
                />
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Additional Notes"
                  multiline
                  rows={4}
                  value={siteNotes}
                  onChange={(e) => setSiteNotes(e.target.value)}
                />
              </Stack>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Card sx={{ marginBottom: "30px" }}>
        <CardContent>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography variant="h6">Client informations</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <TextField
                  fullWidth
                  type="text"
                  name="Client firstname"
                  label="Firstname"
                  // placeholder="Firstname"
                  // value={clientFirstName}
                  value={clientFirstName}
                  onChange={(e) => setClientFirstName(e.target.value)}
                />
                <TextField
                  fullWidth
                  type="text"
                  name="Client lastname"
                  label="Lastname"
                  // placeholder="Lastname"
                  // value={clientLastName}
                  value={clientLastName}
                  onChange={(e) => setClientLastName(e.target.value)}
                />
                <TextField
                  fullWidth
                  type="text"
                  name="Client company"
                  label="Company name"
                  // placeholder="Company name"
                  // value={clientCompany}
                  value={clientCompany}
                  onChange={(e) => setClientCompany(e.target.value)}
                />
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <TextField
                  fullWidth
                  type="email"
                  name="Client email"
                  label="Email address"
                  // placeholder="Email address"
                  // value={clientEmail}
                  value={clientEmail}
                  onChange={(e) => setClientEmail(e.target.value)}
                />
                <TextField
                  fullWidth
                  type="number"
                  name="Client phone number"
                  label="Phone number"
                  // placeholder="Phone number"
                  // value={clientTelephone}
                  value={clientTelephone}
                  onChange={(e) => setClientTelephone(e.target.value)}
                />
              </Stack>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Card sx={{ marginBottom: "30px" }}>
        <CardContent>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography variant="h6">Entrepreneur informations</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <TextField
                  fullWidth
                  type="text"
                  name="Entrepreneur Firstname"
                  label="Firstname"
                  // placeholder="Firstname"
                  // value={entrepreneurFirstName}
                  value={entrepreneurFirstName}
                  onChange={(e) => setEntrepreneurFirstName(e.target.value)}
                />
                <TextField
                  fullWidth
                  type="text"
                  name="Entrepreneur Lastname"
                  label="Lastname"
                  // placeholder="Lastname"
                  // value={entrepreneurLastName}
                  value={entrepreneurLastName}
                  onChange={(e) => setEntrepreneurLastName(e.target.value)}
                />
                <TextField
                  fullWidth
                  type="text"
                  name="Entrepreneur company"
                  label="Company name"
                  // placeholder="Company name"
                  // value={entrepreneurCompany}
                  value={entrepreneurCompany}
                  onChange={(e) => setEntrepreneurCompany(e.target.value)}
                />
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <TextField
                  fullWidth
                  type="text"
                  name="Entrepreneur company number"
                  label="Company number"
                  // placeholder="Company number"
                  // value={entrepreneurCompanyNumber}
                  value={entrepreneurCompanyNumber}
                  onChange={(e) => setEntrepreneurCompanyNumber(e.target.value)}
                />
                <TextField
                  fullWidth
                  type="email"
                  name="Entrepreneur email"
                  label="Email address"
                  // placeholder="Email address"
                  // value={entrepreneurEmail}
                  value={entrepreneurEmail}
                  onChange={(e) => setEntrepreneurEmail(e.target.value)}
                />
                <TextField
                  fullWidth
                  type="number"
                  name="Entrepreneur phone number"
                  label="Phone number"
                  // placeholder="Phone number"
                  // value={entrepreneurTelephone}
                  value={entrepreneurTelephone}
                  onChange={(e) => setEntrepreneurTelephone(e.target.value)}
                />
              </Stack>
            </Grid>
          </Grid>
        </CardContent>
      </Card>{" "}
      <Grid align="right">
        <Button
          variant="contained"
          size="large"
          type="submit"
          // onClick={() => changeCreds()}
          // value={id ? "Update" : "Save"}
        >
          Save changes
        </Button>
        {/* <Button
          variant="contained"
          title="Fetch data"
          type="submit"
          onClick={() => fetchUserCreds()}
        >
          Hein ?
        </Button> */}
      </Grid>
    </form>
  );
};

export default EditSite;

// NEW

// import React, { useEffect, useState, useRef, useReducer } from "react";

// type Action = { type: "read", data: User[] | undefined } | { type: "update" };

// function reducer(state: State, action: Action): State {
//   switch (action.type) {
//     case "read":
//       return {
//         ...state,
//         loading: false,
//         users: action.data,
//       };

//     case "update":
//       return {
//         ...state,
//         modal: false,
//         alert: {
//           show: true,
//           variant: "primary",
//           body: "Modified Successfully!",
//         },
//       };

//     default:
//       return state;
//   }
// }

// const initialValues = {
//   siteStreet: "",
//   siteNumber: "",
// };

// // Refs
// const inputRef = useRef < HTMLInputElement > null;
// const isUpdate = useRef(false);
// const isSubmit = useRef(false);

// // State
// const [formValue, setFormValues] = useState(initialValues);

// const handleInputFocus = () => inputRef.current && inputRef.current.focus();

// const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//   const { value, name } = event.target;

//   setFormValues((prev) => ({
//     ...prev,
//     [name]: value,
//   }));
// };

// const handleReset = () => {
//   if (isUpdate.current) isUpdate.current = false;
//   if (isSubmit.current) isSubmit.current = false;
//   setFormValues(initialValues);
// };

//  const handleUpdate = async () => {
//    const { siteStreet, siteNumber } = formValue;

//    await updateDoc(doc(firestore, APP_COLLECTION, id), {
//      siteStreet,
//      siteNumber,
//      updatedAt: Timestamp.fromDate(new Date()),
//    })
//      .then(() => dispatch({ type: "update" }))
//      .catch((err) => console.log("Error updating document: ", err));

//    setTimeout(() => dispatch({ type: "reset-alert" }), 2000);
//  };

//  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
//    event.preventDefault();
//    isSubmit.current = true;

//    if (isUpdate.current) await handleUpdate();
//    else await handleCreate();
//  };
